import produce from 'immer';

import { SESSION_AUTH_INVALID, MESSAGE_CLEAR, MESSAGE_SET } from 'constants/actions';

export var INITIAL_STATE = {
  items: [],
  lastUpdated: Date.now()
};

export const error = produce((draft, action) => {
  switch (action.type) {
    case SESSION_AUTH_INVALID:
      draft = INITIAL_STATE;
      return draft;

    case MESSAGE_CLEAR:
      draft.items.splice(0, 1);
      draft.lastUpdated = Date.now();
      return draft;

    case MESSAGE_SET:
      draft.items.push(action.value);
      draft.lastUpdated = Date.now();
      return draft;

    default:
      return draft;
  }
}, INITIAL_STATE);

export default error;
